export default function parseQueryParamValue(providedValue, defaultValue) {
  // JSON Parse a providedValue, return default value if not possible
  if (providedValue) {
    try {
      return JSON.parse(providedValue);
    } catch {
      return defaultValue;
    }
  }

  return defaultValue;
}
